import { render, staticRenderFns } from "./SearchLayout.vue?vue&type=template&id=1b31c284&scoped=true&"
import script from "./SearchLayout.vue?vue&type=script&lang=js&"
export * from "./SearchLayout.vue?vue&type=script&lang=js&"
import style0 from "./SearchLayout.vue?vue&type=style&index=0&id=1b31c284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31c284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b31c284')) {
      api.createRecord('1b31c284', component.options)
    } else {
      api.reload('1b31c284', component.options)
    }
    module.hot.accept("./SearchLayout.vue?vue&type=template&id=1b31c284&scoped=true&", function () {
      api.rerender('1b31c284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/list/search/SearchLayout.vue"
export default component.exports